<template>
  <div>
    <van-popup
      :show="open"
      closeable
      round
      position="center"
      @close="handleCancel"
    >
      <section class="login-box">
        <van-form @submit="handleSubmit" ref="loginFormRef">
          <van-cell-group :border="false">
            <van-field
              v-model="formState.tel"
              type="tel"
              label="手机号"
              name="tel"
              placeholder="请输入手机号"
              :border="false"
              :rules="[
                { required: true, message: '请输入手机号' },
                {
                  validator: checkPhone,
                  message: '请输入正确的手机号',
                  trigger: 'onBlur',
                },
              ]"
            />
            <van-field
              v-model="formState.code"
              type="number"
              name="code"
              clearable
              center
              label="验证码"
              placeholder="请输入验证码"
              :rules="[
                { required: true, message: '请输入验证码' },
                {
                  validator: check6Code,
                  message: '请输入6为数字验证码',
                },
              ]"
            >
              <template #button>
                <span
                  @click="handleSendCode"
                  :style="{ color: seconds < 120 ? '' : '#00796c' }"
                  >{{ btnText }}</span
                >
              </template>
            </van-field>
          </van-cell-group>
          <div class="login-btn">
            <van-button round block color="#00796c" native-type="submit">
              登 录
            </van-button>
          </div>
          <div class="info">未注册用户通过验证后自动注册</div>
        </van-form>
      </section>
    </van-popup>
  </div>
</template>
<script setup>
import { ref, reactive, defineProps } from "vue";
import {
  sendCode,
  //  bindPhone,
  loginApi,
} from "@/api/user";
import { Notify, Toast } from "vant";
import store from "@/store";

import { getBigOrigin, isWechatBrowser } from "@/utils/help";

defineProps({ open: Boolean });
const _isWechatBrowser = isWechatBrowser();

const loginFormRef = ref(null);
const formState = reactive({
  tel: "",
  code: "",
});

// 校验规则
function checkPhone(phone) {
  return /^1[3456789]\d{9}$/.test(phone);
}

function check6Code(code) {
  return /^\d{6}$/.test(code);
}

const btnText = ref("发送验证码");
const seconds = ref(120);
const codeSubmitFlag = ref(false);
let inter = null;
const _timer = () => {
  inter = setInterval(() => {
    seconds.value--;
    btnText.value = `${seconds.value}s后重新发送`;
    if (seconds.value <= 0) {
      clearInterval(inter);
      codeSubmitFlag.value = false;
      btnText.value = "发送验证码";
      seconds.value = 120;
    }
  }, 1000);
};
// 获取验证码
const handleSendCode = async () => {
  if (codeSubmitFlag.value) return;
  if (seconds.value < 120) {
    return false;
  }
  if (!checkPhone(formState.tel)) {
    Toast.fail("请输入正确的手机号");
  } else {
    try {
      // const origin = getBigOrigin();
      const params = {
        phone: formState.tel,
        smsSource: "YM_BRAIN_HEALTH", //origin,
        type: _isWechatBrowser ? "conferenceBindLogin" : "pcStudentLogin",
      };
      await sendCode(params);
      Notify({ type: "success", message: "验证码发送成功" });
      // 定时器
      _timer();
    } catch (error) {
      console.error(error);
      Notify({ type: "warning", message: "验证码发送失败" });
    }
  }
};

const handleCancel = () => {
  loginFormRef.value.resetValidation();
  store.commit("user/setH5LoginPop", false);
};
//提交表单
let btn_lock = false;
const handleSubmit = async () => {
  if (btn_lock) {
    return false;
  }
  const origin = getBigOrigin();
  try {
    btn_lock = true;
    let res;
    // if (_isWechatBrowser) {
    //   const params = {
    //     phone: formState.tel,
    //     smsCode: formState.code,
    //     source: store.getters["config/getConfig"].wechatAccountSource,
    //     platformId: store.getters["config/getConfig"].platformId,
    //   };
    //   // 微信浏览器则是绑定手机
    //   const { results } = await bindPhone(params);
    //   res = results;
    // } else {
    const params = {
      phone: formState.tel,
      code: formState.code,
      source: origin,
      platformId: store.getters["config/getConfig"].platformId,
    };
    const { results } = await loginApi(params);
    res = results;
    // }
    if (res.token) {
      localStorage.setItem("token", res.token.split(" ")[1]);
      store.commit("user/setUserInfo", res);
      localStorage.setItem("phone", formState.tel);
    }
    Toast.success("登录成功");
    handleCancel();
    btn_lock = false;
  } catch (error) {
    btn_lock = false;
    console.error(error);
    Toast.fail("登录失败");
  }
};
</script>

<style scoped lang="less">
// .login-wrapper {
//   min-height: 100%;
//   padding: 0 32px;
//   .title {
//     font-size: 32px;
//     font-weight: 500;
//     margin: 54px 0;
//   }
.login-box {
  width: 311px;
  padding: 24px;
  .btn {
    padding: 20px var(--van-cell-horizontal-padding);
  }
  /deep/ .van-cell {
    padding-left: 0;
  }
  /deep/ input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px #fff inset;
  }
  // /deep/ .van-cell-group {
  //   margin-bottom: 46px;
  // }
  .login-btn {
    padding: 16px 0;
  }
  .info {
    text-align: center;
    font-size: 14px;
    // margin: 12px 0 46px 0;
    color: rgba(0, 0, 0, 0.65);
  }
}
// }
</style>
